var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { sportSortFunc } from '../../../rendering-commons/Sorting';
import * as DisplayMode from '../../../constants/DisplayMode';
import Sport from './Sport';
var LivePage = function (props) {
    var sports = props.sports, gridLocalization = props.gridLocalization, displayMode = props.displayMode;
    var renderSports = [];
    var sportProps = {
        gridLocalization: gridLocalization,
        section: 'live',
        displayMode: displayMode
    };
    sports.sort(sportSortFunc).map(function (s, i) {
        if (displayMode.type === DisplayMode.ALL) {
            renderSports.push(_jsx(Sport, __assign({ sport: s }, sportProps, { showSport: true }), i));
        }
        else if (displayMode.type === DisplayMode.SPORT && displayMode.id === s.get('id')) {
            renderSports.push(_jsx(Sport, __assign({ sport: s }, sportProps, { showSport: false }), i));
        }
    });
    return (_jsx("div", __assign({ className: 'content' }, { children: _jsx("div", __assign({ className: 'blc blc_best' }, { children: renderSports })) })));
};
LivePage.propTypes = {
    gridLocalization: PropTypes.object.isRequired,
    sports: PropTypes.object.isRequired
};
var mapStateToProps = function (state) { return ({
    routing: state.routing,
    fetching: state.application.getIn(['live', 'fetching']),
    sports: state.application.getIn(['live', 'sports']),
    languageId: state.application.get('languageId'),
    displayMode: state.application.get('displayMode')
}); };
LivePage = connect(mapStateToProps)(LivePage);
export default LivePage;



// WEBPACK FOOTER //
// ./src/components/grid/live/LivePage.jsx